import {
    GET_SALES_REGISTER_REPORT_PROGRESS, GET_SALES_REGISTER_REPORT_SUCCESS, GET_SALES_REGISTER_REPORT_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    salesRegister: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const sales_register_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALES_REGISTER_REPORT_SUCCESS:
            return { ...state, salesRegister: action.salesRegister, loading: false };
        case GET_SALES_REGISTER_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_REGISTER_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
      
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default sales_register_report_reducer;